// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--f26a0";
export var symbol = "Footer-module--symbol--26804";